// Generated by ReScript, PLEASE EDIT WITH CARE


let baseRoute = "/design-system";

export {
  baseRoute,
}
/* No side effect */
